import ChooseCoupon from './ChooseCoupon';

export default (props) => {
  return <ChooseCoupon {...props} />;
};
